import { render } from "./HandlerIos.vue?vue&type=template&id=2cf40203&scoped=true"
import script from "./HandlerIos.vue?vue&type=script&lang=js"
export * from "./HandlerIos.vue?vue&type=script&lang=js"

import "./HandlerIos.vue?vue&type=style&index=0&id=2cf40203&lang=scss&scoped=true"

import exportComponent from "/var/www/production/app.labparahita.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cf40203"]])

export default __exports__